export interface MessageContent {
  $type: string;
  text?: string;
  callId?: string;
  name?: string;
  arguments?: Record<string, unknown>;
  informationalOnly?: boolean;
  result?: unknown;
}

export interface Message {
  authorName?: string;
  createdAt: string;
  role: "user" | "assistant" | "tool";
  contents: MessageContent[];
  messageId: string;
}

export interface ChatHistoryProviderState {
  messages: Message[];
}

export interface ChatState {
  chatHistoryProviderState: ChatHistoryProviderState;
}

export function getLastNMessages(state: ChatState, n: number = 10): ChatState {
  const messages = state.chatHistoryProviderState.messages;
  const lastN = messages.slice(-n);

  return {
    ...state,
    chatHistoryProviderState: {
      ...state.chatHistoryProviderState,
      messages: lastN,
    },
  };
}
